import React from 'react';
import styles from './MedicalReportsList.module.scss';
import MedicalReportsListItem from './MedicalReportsListItem';
import useScrollGuard from '../../Base/Hooks/useScrollGuard';
import ScrollContainer from '../../Base/Components/ScrollContainer';
import FlatList from '../../Base/Components/FlatList';

interface Props {
	data: Document[];
	isLoading: boolean;
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
}

const wrapperId = 'medicalReportsWrapper';

const MedicalReportsList: React.FC<Props> = ({
	data,
	isLoading,
	onRefresh,
	onLoadMore,
	hasMoreData,
}) => {
	const { scrollContainerRef } = useScrollGuard<Document>({
		data,
		isLoading,
		onLoadMore,
		hasMoreData,
	});

	return (
		<ScrollContainer
			wrapperId={wrapperId}
			className={styles.list}
			ref={scrollContainerRef}>
			<FlatList
				onRefresh={onRefresh}
				onLoadMore={onLoadMore}
				data={data}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={wrapperId}
				renderItem={item => (
					<MedicalReportsListItem item={item} onRefresh={onRefresh} />
				)}
			/>
		</ScrollContainer>
	);
};

export default MedicalReportsList;
